import Nav
 from './Nav'
import React from 'react'

const Invoice = () => {
    return (
        <div>
        <Nav/>
        <h1>invocie</h1>
    </div>
    )
}

export default Invoice
